import { useEffect, useState } from "react";
import { UserCheck, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { CLASS_LABEL } from "@/components/FareBreakdown";

const Avatar = ({ d }) => d.photo_url
  ? <img src={d.photo_url} alt={d.first_name} className="h-10 w-10 rounded-full object-cover" />
  : <span className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-500/40 bg-amber-400/10 font-serif text-amber-200">{d.first_name?.[0]}</span>;

const DriverChip = ({ d, onClick, active, testId }) => (
  <button type="button" data-testid={testId} onClick={onClick}
    className={`flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-colors ${active ? "border-amber-400 bg-amber-400/10" : "border-white/10 hover:border-amber-500/40"}`}>
    <Avatar d={d} />
    <span className="min-w-0 flex-1"><span className="block text-sm text-amber-100">{d.first_name}</span><span className="block text-xs text-zinc-500">{CLASS_LABEL[d.vehicle_class]} · {d.driver_code}</span></span>
  </button>
);

export const RequestDriver = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [past, setPast] = useState([]);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  useEffect(() => { if (open) api.get("/customer/past-drivers").then(({ data }) => setPast(data)).catch(() => {}); }, [open]);
  const find = async () => {
    setError("");
    try { onChange((await api.get(`/drivers/lookup/${encodeURIComponent(code.trim())}`)).data); setCode(""); }
    catch (e) { setError(e.response?.status === 404 ? "Driver not found" : errMsg(e)); }
  };
  if (value) return (
    <div className="lux-card flex items-center gap-3 p-4" data-testid="requested-driver-selected">
      <Avatar d={value} />
      <p className="min-w-0 flex-1 text-sm"><span className="lux-eyebrow block">Requested driver</span><span className="text-amber-100" data-testid="requested-driver-name">{value.first_name}</span> <span className="text-xs text-zinc-500">{value.driver_code}</span></p>
      <button type="button" data-testid="requested-driver-clear" onClick={() => onChange(null)} className="text-zinc-400 hover:text-red-300"><X className="h-4 w-4" /></button>
    </div>
  );
  return (
    <div className="lux-card space-y-3 p-5 sm:p-6" data-testid="request-driver">
      <button type="button" data-testid="request-driver-toggle" onClick={() => setOpen(!open)} className="inline-flex items-center gap-2 text-sm font-medium text-amber-300 hover:text-amber-200">
        <UserCheck className="h-4 w-4" /> Request a driver <span className="text-zinc-500">(optional)</span>
      </button>
      {open && (
        <>
          <p className="lux-eyebrow">Your past drivers</p>
          {past.length === 0 && <p data-testid="past-drivers-empty" className="text-xs text-zinc-500">No past drivers yet.</p>}
          <div className="space-y-2">{past.map((d) => <DriverChip key={d.driver_code} d={d} testId={`past-driver-${d.driver_code}`} onClick={() => onChange(d)} />)}</div>
          <div className="flex gap-2">
            <input data-testid="driver-id-input" className="lux-input min-w-0 flex-1 uppercase" placeholder="Driver ID e.g. LR-1042" value={code} onChange={(e) => setCode(e.target.value)} />
            <button type="button" data-testid="driver-id-find-button" disabled={!code.trim()} onClick={find} className="btn-outline-gold !px-5">Find</button>
          </div>
          {error && <p data-testid="driver-not-found" className="text-xs font-medium text-amber-500">{error}</p>}
        </>
      )}
    </div>
  );
};
